<template>
  <b-modal ref="modal" :hideFooter="true" size="md" title="Users Arrangement">
    <draggable v-model="arrangement" @start="drag=true" @end="drag=false" @change="onPlaceChange">
      <div v-for="piece in arrangement" :key="piece.userId" class="ui-draggable-handle draggable-user" :class="{'user-hidden': !piece.show}">
        <div class="icon-wrapper mr-2">
          <i class="fas fa-thumbtack"></i>
        </div>
         {{ getUserName(piece.userId) }}
        <div class="icon-wrapper ml-auto hider" @click="piece.show = !piece.show">
          <i class="fas " :class="{'fa-eye': piece.show, 'fa-eye-slash': !piece.show}"></i>
        </div>
      </div>
    </draggable>

    <button class="btn btn-metal mt-5" @click="onSave">Save</button>
  </b-modal>
</template>

<script>
  import bModal from 'bootstrap-vue/es/components/modal/modal'
  import draggable from 'vuedraggable'

  export default {
    components: {
      bModal,
      draggable
    },
    props: ['user', 'users'],
    data() {
      return {
        arrangement: [],
      }
    },
    methods: {
      open() {
        this.$refs.modal.show()
        this.fillArrangementWithMissingUsers()
      },

      fillArrangementWithMissingUsers() {
        this.arrangement = JSON.parse(this.user.agendaArrangement) || []
        const loadedUsers = this.users.filter(user => !user.hide_from_dashboard)

        // Check if all users in saved arrangement exist in loaded users
        if (this.arrangement.length > 0)
          this.arrangement = this.arrangement.filter(piece => {
            const loadedUser = loadedUsers.find(user => user.id === piece.userId)
            if (loadedUser)
              return loadedUser
          })

        const usersIdsInArrangement = this.arrangement.map(piece => piece.userId)
        let lastOrder = this.findBiggestOrder()

        // Fill users to arrangement who hasn't been added yet
        loadedUsers.forEach(user => {
          if (!usersIdsInArrangement.includes(user.id || -1))
            this.arrangement.push({
              userId: user.id,
              order: ++lastOrder,
              show: true
            })
        })
      },

      findBiggestOrder() {
        if (this.arrangement.length <= 0) {
          return -1;
        }

        let max = this.arrangement[0].order || -1
        this.arrangement.forEach(piece => {
          const pieceOrder = piece.order || -1
          if (pieceOrder > max) {
            max = pieceOrder
          }
        })

        return max;
      },

      onPlaceChange(event) {
        this.arrangement = this.arrangement.map((piece, i) => {
          piece.order = i
          return piece
        })
      },

      onSave() {
        const data = {
          user_id: this.user.id,
          arrangement: JSON.stringify(this.arrangement)
        }

        this.axios.post('/agendaArrangement', data)
          .then(res => {
            this.$emit('agendaArrangementUpdated', JSON.stringify(this.arrangement))
            this.$refs.modal.hide()
          })
          .catch(err => {})
      },

      getUserName(userId) {
        const user = this.users.find(user => userId === user.id)

        if (user)
          return user.name

        return null
      }
    }
  }
</script>

<style scoped>
  .draggable-user {
    font-size: 1.3rem;
    width: 100%;
    background-color: #F3F3F3;
    margin-bottom: 4px;
    border: 1px solid #C0C3BF;
    border-radius: 5%;
    padding: 5px;
    display: flex;
  }

  .fas {
    color: #72748B;
    font-size: 1.2rem;
  }

  .icon-wrapper {
    display: flex;
    align-items: center;
  }

  .hider {
    cursor: pointer;
  }

  .hider .fas {
    font-size: 1.4rem;
  }

  .user-hidden {
    background: repeating-linear-gradient(
      -55deg,
      #222,
      #222 10px,
      #333 10px,
      #333 20px
    );
    color: #D4D7D3;
  }

  .user-hidden .fas {
    color: #00aabd;
  }
</style>



// WEBPACK FOOTER //
// src/views/agenda/Arrangement.vue